import { render, staticRenderFns } from "./reviewOpinion.vue?vue&type=template&id=cecf5dfc&scoped=true&"
import script from "./reviewOpinion.vue?vue&type=script&lang=js&"
export * from "./reviewOpinion.vue?vue&type=script&lang=js&"
import style0 from "./reviewOpinion.vue?vue&type=style&index=0&id=cecf5dfc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cecf5dfc",
  null
  
)

export default component.exports